module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-darkmode-change.399c5811.png";